import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RotateCcw, LogOut, BarChart3 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';

function Sidebar({ currentProject, user, selectedPoint, setSelectedPoint, analysisPoints }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleChangeProject = () => {
    localStorage.removeItem('currentProject');
    navigate('/projects');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <BarChart3 size={24} />
        <h2>Consultoría Analyzer</h2>
      </div>

      {currentProject && (
        <div className="project-info">
          <div className="user-info">
            <strong>Usuario:</strong> {user?.username}
          </div>
          <div className="project-name">
            <strong>Proyecto:</strong> {currentProject.name}
          </div>
        </div>
      )}

      <div className="analysis-points">
        <h3>Punto de análisis:</h3>
        <div className="points-list">
          {analysisPoints.map(point => (
            <button
              key={point.number}
              className={`point-btn ${selectedPoint === point.number ? 'active' : ''}`}
              onClick={() => setSelectedPoint(point.number)}
            >
              {point.number}. {point.title}
            </button>
          ))}
        </div>
      </div>

      <div className="sidebar-actions">
        <button onClick={handleChangeProject} className="action-btn">
          <RotateCcw size={16} />
          Cambiar Proyecto
        </button>
        <button onClick={handleLogout} className="action-btn">
          <LogOut size={16} />
          Cerrar Sesión
        </button>
      </div>

      <div className="sidebar-footer">
        <p>Made by Kuik! Inteligencia Artificial S.L.</p>
      </div>
    </aside>
  );
}

export default Sidebar;